'use strict';

/*@ngInject*/
module.exports = function($stateProvider, $urlRouterProvider) {
    $urlRouterProvider.otherwise('/');
    var _=require('underscore');
    
    $stateProvider
        
        // default state
        .state('home', {
            url: '/',

            // params: {scrollTo: 'video',},
            views: {
            	'': {
            		templateUrl: 'views/_index.html',
                    controller: 'homeController'                    
            	},

                'video@home': {
                    templateUrl: 'views/_video.html',
                    controller: 'featureVideoController'
                },
            
                
                'carousel@home': {
                    templateUrl: 'views/_carousel.html',
                    controller: 'carouselController'
                },
            	'feedHome@home': {
            		templateUrl: 'views/_feed-home.html'
            	},
                'feed@home': {
                    templateUrl: 'views/_feed.html',
                    controller: 'feedController'
                },
                'newsroom@home': {
                    templateUrl: 'views/_newsroom.html',
                    controller: 'newsroomController'
                }
            },
            data: {
                feedUrl: 'https://securingtomorrow.mcafee.com/category/consumer/family-safety/feed?cat=12',
                feedCount: 3
            }
        })

        .state('feature', {
            url: '/feature',
            views: {
                '': {
                    templateUrl: 'views/_feature-videos.html',
                    controller: 'featureVideoController'
                }
            }
        })

        .state('redirect', {
            url: '/redirect',
            views: {
                '': {
                    templateUrl: 'views/_redirectDownload.html',
                    controller: 'redirectController'
                }
            }
        })

                
         .state('getstart', {
            url: '/getstart',
            params: {videoId: '1'},
            views: {
                '': {
                    templateUrl: 'views/_feature-getstart.html',
                    controller: 'featureVideoController'
                }
            }
        })

        .state('featureactivity', {
            url: '/featureactivity',
            params: {videoId: '2'},
            views: {
                '': {
                    templateUrl: 'views/_feature-activity.html',
                    controller: 'featureVideoController'
                }
            }
        })


      .state('featurepermission', {
            url: '/featurepermission',
            params: {videoId: '3'},
            views: {
                '': {
                    templateUrl: 'views/_feature-permission.html',
                    controller: 'featureVideoController'
                }
            }
        })
        .state('featuremap', {
            url: '/featuremap',
            params: {videoId: '4'},
            views: {
                '': {
                    templateUrl: 'views/_feature-map.html',
                    controller: 'featureVideoController'
                }
            }
        })



      .state('featurerules', {
            url: '/featurerules',
            params: {videoId: '5'},
            views: {
                '': {
                    templateUrl: 'views/_feature-rules.html',
                    controller: 'featureVideoController'
                }
            }
        })
        .state('featureios', {
            url: '/featureios',
            params: {videoId: '0',},
            views: {
                '': {
                    templateUrl: 'views/_feature-ios.html',
                    controller: 'featureVideoController'
                    
                }
            }            
        })



        .state('newsroom', {
            url: '/newsroom',
            views: {
            	'': {
            		templateUrl: 'views/_newsroom.html',
                    controller: 'newsroomController'
            	},
            	'feed@newsroom': {
                    templateUrl: 'views/_feed.html',
                    controller: 'feedController'
                }
            },
            data: {
                feedUrl: 'https://securingtomorrow.mcafee.com/category/consumer/family-safety/feed?cat=12',
                feedCount: 5
            }
        })
        .state('article', {
            url: '/artice/:link',
            views: {
            	'': {
            		templateUrl: 'views/_article.html',
                    controller: 'articleController'
            	},
                'feed@article': {
                    templateUrl: 'views/_feed.html',
                    controller: 'feedController'
                }
            },
            data: {
                postFeedSuffix: '/feed?withoutcomments=1',
                feedUrl: 'https://securingtomorrow.mcafee.com/category/consumer/family-safety/feed?cat=12',
                feedCount: 2
            }
        })

        .state('download', {
            url: '/download',
            views: {
                '': {
                    templateUrl: 'views/_windows.html',
					controller: 'downloadController'
                }
            }
        })

        .state('undl', {
            url: '/undl',
            views: {
                '': {
                    templateUrl: 'views/_unsupported-platform.html'
                }
            }
        });

    


};